<template>
  <loader v-if="loader" />
  <div v-else>
    <div class="date-and-timezone">
      <div
        :class="[
          'calendar-inline-container',
          { 'calendar-inline_without-padding': withoutPadding },
        ]">
        <datepicker
          :class="[
            'calendar-inline',
            { 'calendar-inline_without-padding': withoutPadding },
          ]"
          :inline="true"
          :lang="globalSettingCalendar"
          :disabled-date="disabledDays"
          v-model="calendar"
          value-type="format"
          @change="selectDate"
          @calendar-change="changeMonthInCalendar"
          :key="keyCalendar" />
        <div class="calendar-inline-description">
          <span
            class="registration calendar-inline-description-text is-available">
            {{ $t("mc.calendar.registrationPossible") }}
          </span>
          <span class="registration registration-imposible">
            {{ $t("mc.calendar.registrationInpossible") }}
          </span>
        </div>
      </div>
      <div class="right-panel">
        <span class="right-panel__title" v-if="type === 'new-mk'">
          AmoCRM Link
        </span>
        <form
          @submit.prevent="searchLead"
          class="slots-selected-amo"
          v-if="type === 'new-mk'">
          <input
            type="text"
            class="input-text slots-selected-amo__input"
            placeholder="https://kodland.amocrm.ru/leads/detail/XXXX"
            v-model="amoLink" />
          <button
            class="btn btn_blue btn_h46 btn_width-auto"
            @click="searchLead"
            :disabled="!amoLink || disabledButton">
            {{ $t("mc.placeholders.search") }}
          </button>
        </form>
        <loader v-if="loaderLead" />
        <div v-else>
          <span class="right-panel__title">{{ title }}</span>

          <div class="slots-list" v-if="slotsSelectDay.length">
            <div
              class="slots-list-time"
              @click="selectSlot(item.id)"
              v-for="item in slotsSelectDay"
              :key="item.id">
              <div
                :class="[
                  'slots-list-time-content',
                  { selected: item.selected },
                ]">
                <div
                  :class="[
                    'slot-filled-circle',
                    { 'slot-filled-circle_military': !isMilitaryTime },
                  ]"
                  :style="{
                    background: calculateSlotsForGradient(item.available),
                  }" />
                {{ item.time }}
              </div>
            </div>
          </div>
          <b v-if="selectedSlot.id" class="slots-avail">
            {{ $t("mc.slots.availableSlots") }}: {{ selectedSlot.available }}
          </b>
          <br />
          <span class="right-panel__title">
            {{ $t("mc.detailsMc.startMcByClient") }}
          </span>
          <div v-if="lead">
            <div class="slots-lead" v-if="lead.phone">
              <b v-if="!lead.client_tz_name">
                {{ $t("mc.searchLead.tzFindInAmo") }}
              </b>
              <b v-if="lead.client_tz_name">
                {{ $t("mc.searchLead.phoneFindInAmo") }}
              </b>
              <br />
              <span>
                {{ $t("mc.searchLead.country") }}: {{ lead.country_name }}
              </span>
              <br />
              <span class="slots-lead-phone">
                {{ $t("mc.searchLead.phone") }}:&nbsp;
                <span class="slots-lead-phone__flag">
                  <CountryFlag
                    :country="lead.country_code"
                    size="small"
                    :shadow="true" />
                  {{ lead.phone }}
                </span>
              </span>
            </div>
            <div
              class="slots-lead"
              v-if="lead && !lead.phone && lead.client_tz_name">
              <b>{{ $t("mc.searchLead.tzFindInAmo") }}</b>
            </div>
            <div
              class="slots-lead"
              v-if="lead && !lead.phone && !lead.client_tz_name">
              <b>{{ $t("mc.searchLead.notFoundTzInAmo") }}</b>
            </div>
          </div>

          <label
            class="checkbox order-timezone-checkbox"
            @change="toggleSelect"
            v-if="timezones_suggested.length">
            <input
              type="checkbox"
              class="checkbox-input"
              id="finished"
              v-model="showTimezonesSuggested" />
            <span>
              <inline-svg
                class="checkbox__icon"
                :src="require(`@/assets/svg/checkbox.svg`)" />
            </span>
            {{ $t("mc.searchLead.onlyTzClient") }}
          </label>
          <v-select
            v-if="!showTimezonesSuggested"
            :searchable="true"
            :clearable="false"
            :options="timezones"
            v-model="selectedTimezone"
            :value="selectedTimezone"
            label="label"
            @input="changeTimezone"
            class="order-timezone">
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <img src="@/assets/svg/select-chevron.svg" />
              </span>
            </template>
          </v-select>
          <v-select
            v-if="timezones_suggested.length && showTimezonesSuggested"
            :searchable="true"
            :clearable="false"
            :options="timezones_suggested"
            v-model="selectedTimezone"
            :value="selectedTimezone"
            label="label"
            @input="changeTimezone"
            class="order-timezone">
            <template #open-indicator="{ attributes }">
              <span v-bind="attributes">
                <img src="@/assets/svg/select-chevron.svg" />
              </span>
            </template>
          </v-select>
          <Tags style="margin-top: 15px;margin-bottom: 15px;" @saveEntityTags="setSaveTagsFunction" entity-type="booking" :entity-id="mkId || false"></Tags>
          <div class="slots-selected" v-if="selectedSlot.id">
            <span class="label">
              <span>
                {{ $dayjs(clientTime).format(`DD MMMM YYYY ${formatTime}`) }}
                {{ $t("mc.calendar.callTime") }}
              </span>
            </span>
            <div v-if="type === 'new-mk'">
              <button
                class="btn btn_blue btn_h46 btn_width-auto new-mk__button"
                :disabled="!amoLink || disabledButton"
                @click="createMk">
                {{ isSegmentForFreeCourse ? $t('mc.slots.signupForFreeCourse') : $t('mc.slots.createMk') }}
              </button>
            </div>
            <div v-if="type === 'reschedule'">
              <slot name="reasonAndComment" />
              <button
                class="btn btn_blue btn_h46 btn_width-auto new-mk__button"
                :disabled="disabledButton"
                @click="rescheduleMk">
                {{ $t("mc.slots.save") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="[
        'new-mk-comment',
        { 'new-mk-comment_without-padding': type === 'reschedule' },
      ]">
      <label class="label">
        {{ $t("mc.slots.comment") }}
        <span class="label_grey">({{ $t("mc.slots.notRequired") }})</span>
      </label>
      <input
        type="text"
        :placeholder="$t('mc.placeholders.inputComment')"
        class="input-text"
        v-model="additional_info" />
    </div>
  </div>
</template>

<script>
import apiTimeslots from "@/api/master-classes/timeslots";
import apiBooking from "@/api/master-classes/booking";
import apiUser from "@/api/user";
import globalSettingCalendar from "@/helpers/globalSettingCalendar";
import militaryAndLanguage from "@/helpers/militaryAndLanguage";
import Tags from "../Supervisor/Tags";
import { getTimeZones } from "@vvo/tzdb";
import CountryFlag from "vue-country-flag";
import Vue from "vue";

export default {
  components: {
    CountryFlag,Tags
  },
  props: {
    triggerToDisableSaveButton: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    withoutPadding: {
      type: Boolean,
      required: false,
    },
    type: {
      type: String,
      required: true,
      default: "new-mk",
    },
    additionalInfoLoad: {
      type: String,
      required: false,
    },
    mkId: {
      type: String,
      required: false,
    },
    page: {
      type: String,
      required: false,
    },
    reason: {
      type: [String, Boolean],
      required: false,
    },
    comment: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      militaryAndLanguage,
      globalSettingCalendar,
      loader: false,
      keyCalendar: 0,
      calendar: "",
      segmentInfo: "",
      additional_info: "",
      timezones: [],
      timezones_suggested: [],
      selectedTimezone: "",
      slots: [],
      slotsSelectDay: [],
      selectedSlot: [],
      clientTime: "",
      amoLink: "",
      lead: "",
      loaderLead: false,
      showTimezonesSuggested: false,
      disabledButton: true,
    };
  },
  computed: {
    formatTime() {
      return !this.isMilitaryTime ? "hh:mm a" : "HH:mm";
    },
    isMilitaryTime() {
      let military = null;
      military = this.militaryAndLanguage();
      return military;
    },
    dateTzForClient() {
      if (this.getOffset() > this.offset) {
        return this.defaultOffset - this.getOffset();
      } else {
        return -this.getOffset() + this.defaultOffset;
      }
    },
    defaultOffset() {
      return this.$store.state.user.segment.tz_offset;
    },
    defaultTz() {
      return this.$store.state.user.segment.timezone_name;
    },
    segmentId() {
      return this.$store.state.user.segment.id;
    },
    segment() {
      return this.$store.state.user.segment
    },
    isSegmentForFreeCourse() {
      return this.segment.title === 'RU TC FC' ||
          +this.segment.id === 36 ||
          +this.segment.id === 30 ||
          +this.segment.id === 38
    },
  },
  methods: {
    setSaveTagsFunction(func = () => {}) {
      if (typeof func === 'function') this.saveBookingTags = func
    },
    toggleSelect() {
      const segment = this.$store.state.user.segment;

      if (!this.showTimezonesSuggested) {
        this.selectedTimezone =
          this.timezones.find((el) => el.name === segment.timezone_name) ||
          this.timezones.find((el) => el.tz == segment.tz_offset);
      } else {
        this.selectedTimezone = this.timezones_suggested[0];
      }
    },
    async searchLead() {
      const segment = this.$store.state.user.segment;

      const findSuggestedTimezone = (timezones) => {
        this.timezones_suggested = timezones.map((el) => {
          const isNegativeMinutes = el.tz_offset / 60 < 0;
          const returnObject = {
            utc: this.fromMinutesToHHMM(el.tz_offset / 60, isNegativeMinutes),
            name: el.name,
            label: `(UTC ${this.fromMinutesToHHMM(
              el.tz_offset / 60,
              isNegativeMinutes
            )}) ${el.name}`,
            tz: el.tz_offset,
          };

          return returnObject;
        });

        this.showTimezonesSuggested = true;
        this.selectedTimezone = this.timezones_suggested[0];
      };

      this.disabledButton = true;
      this.loaderLead = true;
      try {
        this.lead = await apiBooking.getInfoLead(
          this.amoLink.substr(this.amoLink.lastIndexOf("/") + 1)
        );

        if (this.lead.phone && !this.lead.client_tz_name) {
          findSuggestedTimezone(this.lead.suggested_timezones);
          this.selectedTimezone = this.timezones_suggested[0];
        } else if (this.lead.client_tz_name) {
          const findTimezone = this.timezones_suggested.find(
            (el) => el.name === this.lead.client_tz_name
          );
          if (findTimezone) {
            this.selectedTimezone = findTimezone;
          } else {
            findSuggestedTimezone(this.lead.suggested_timezones);
          }
        } else {
          this.showTimezonesSuggested = false;
          this.selectedTimezone =
            this.timezones.find((el) => el.name === segment.timezone_name) ||
            this.timezones.find((el) => el.tz == segment.tz_offset);
        }
        this.selectedSlot = [];
        this.slotsSelectDay.forEach((el) => (el.selected = false));
      } catch (e) {
        console.log("sd");
      }
      this.loaderLead = false;
      this.disabledButton = false;
    },
    calculateSlotsForGradient(number) {
      if (number >= 50) return "#00FF00";
      if (number < 50 && number >= 40) return "#7DFA7C";
      if (number < 40 && number >= 30) return "#A0FF9A";
      if (number < 30 && number >= 20) return "#BAFF78";
      if (number < 20 && number >= 10) return "#EFF21A";
      if (number < 10 && number >= 5) return "#FFBD84";
      if (number < 5) return "#FF9AAF";
    },
    disabledDays(date) {
      const dates = this.slots.map((el) => el._id);
      const day = this.$dayjs(new Date(date)).format("YYYY-MM-DD");
      return dates.indexOf(day) === -1;
    },
    selectSlot(id) {
      this.slotsSelectDay.forEach((el) => (el.selected = false));
      const idxSlot = this.slotsSelectDay.findIndex((el) => el.id === id);
      this.slotsSelectDay[idxSlot].selected = true;
      this.selectedSlot = this.slotsSelectDay[idxSlot];

      this.calculateClientTime();
    },
    getOffset(hm) {
      const time = hm
        ? hm.utc.substring(1, 6)
        : this.selectedTimezone.utc.substring(1, 6);
      // const hm = this.selectedTimezone.utc.substring(1,6);
      const a = time.split(":");
      const seconds = +a[0] * 60 * 60 + +a[1] * 60;
      const firstSymbol = this.selectedTimezone.utc.substring(0, 1);
      return firstSymbol === "-" ? -seconds : seconds;
    },
    async getServerSlots(firstDay, date) {
      const segment = this.$store.state.user.segment;
      this.slotsSelectDay = [];
      this.loader = true;

      // если firstDay == true, то передаем дату с первым днем месяца
      // иначе текущий день
      if (firstDay) {
        this.calendar = `${date.year}-${"0" + date.month}-01`;
      } else {
        this.calendar = this.startDate;
      }

      let serversSlots;

      // если firstDay == true, то запрашиваем по дате с первым днем месяца
      // иначе запрашиваем слоты начиная с текущего дня
      if (firstDay) {
        serversSlots = await apiTimeslots.getMonthTimeslots(
          this.$dayjs(this.calendar).format("YYYY-MM-01T00:00"),
          segment.tz_offset
        );
      } else {
        //Было до полного выпиливания this.differenceSeconds
        serversSlots = await apiTimeslots.getMonthTimeslots(
          this.$dayjs(this.$dayjs().utcOffset(0))
            .add(segment.tz_offset, "second")
            .format("YYYY-MM-DDTHH:mm"),
          segment.tz_offset
        );
      }

      this.slots = serversSlots;

      // выбираем в календаре день, чтобы вывести список слотов
      // после загрузки с сервера
      if (serversSlots.length) {
        this.calendar = serversSlots[0]._id;
        this.slotsSelectDay = [];
        this.selectDate(serversSlots[0]._id);
      }

      this.selectedTimezone =
        this.timezones.find((el) => el.name === segment.timezone_name) ||
        this.timezones.find((el) => el.tz == segment.tz_offset);

      this.loader = false;
    },
    selectDate(date) {
      this.selectedSlot = "";
      const findDay = this.slots.find((el) => el._id === date);
      if (findDay) {
        this.slotsSelectDay = findDay.items.map((el) => {
          return {
            id: el.id,
            fulldate: el.slot_starts_at,
            time: this.$dayjs(el.slot_starts_at, "YYYY-MM-DD HH:mm").format(
              this.formatTime
            ),
            selected: false,
            available: el.overbooking_capacity - el.mk_booked,
          };
        });
      } else {
        this.slotsSelectDay = [];
      }
    },
    changeMonthInCalendar(value) {
      const month = value.getMonth();
      const year = value.getFullYear();
      if (month + 1 > +this.$dayjs(this.startDate).format("M")) {
        this.getServerSlots(true, { month: month + 1, year });
      } else if (month + 1 == +this.$dayjs(this.startDate).format("M")) {
        this.getServerSlots(false, undefined, true);
      }
    },
    calculateClientTime() {
      let offsetClient;

      if (this.defaultOffset < this.selectedTimezone.tz) {
        offsetClient = this.defaultOffset - this.selectedTimezone.tz;
      } else {
        offsetClient = -this.selectedTimezone.tz + this.defaultOffset;
      }

      this.clientTime = this.$dayjs(this.selectedSlot.fulldate)
        .subtract(offsetClient, "second")
        .format("YYYY-MM-DD HH:mm");
    },
    changeTimezone() {
      this.calculateClientTime();
    },
    async createMk() {
      let date = "";
      if (!this.isMilitaryTime) {
        date = this.$dayjs(
          `${this.calendar}T${this.selectedSlot.time}`,
          `YYYY-MM-DDThh:mm a`
        ).format(`YYYY-MM-DDTHH:mm`);
      } else {
        date = this.$dayjs(
          `${this.calendar}T${this.selectedSlot.time}`,
          `YYYY-MM-DDTHH:mm`
        ).format(`YYYY-MM-DDTHH:mm`);
      }
      this.disabledButton = true;

      const bookingObject = {
        amocrm_id: this.amoLink,
        tz_offset: this.defaultOffset,
        mk_starts_at: date,
        mk_ends_at: this.$dayjs(date, "YYYY-MM-DDTHH:mm")
          .add(1, "hour")
          .format("YYYY-MM-DDTHH:mm"),
        additional_info: this.additional_info,
        client_time: this.$dayjs(this.clientTime, "YYYY-MM-DD HH:mm").format(
          `YYYY-MM-DD HH:mm:00.000${this.selectedTimezone.utc}`
        ),
        client_timezone_text: this.selectedTimezone.name,
        client_tz_offset: this.selectedTimezone.tz,
      };
      let booking

      if (this.isSegmentForFreeCourse) {
        booking = await apiBooking.newBookingFreeCourse(bookingObject)
      } else {
        booking = await apiBooking.newBooking(bookingObject)
      }

      if (booking) {
        try {
          await this.saveBookingTags(booking.id)
        } catch (e) {
          Vue.toasted.global.all_mistake('save tags error')
        }
        let time = !this.isMilitaryTime ? "hh:mm a" : "HH:mm";
        this.$toasted.global.all_ok(
          `${this.$t("mc.toasts.mcCreated")} ${this.$dayjs(date).format(
            `DD.MM.YYYY ${time}`
          )}`
        );
        await this.getServerSlots(false, undefined, true);
      }
      this.amoLink = "";
      this.disabledButton = false;
    },
    async rescheduleMk() {
      this.disabledButton = true;
      let date = "";
      if (!this.isMilitaryTime) {
        date = this.$dayjs(
          `${this.calendar}T${this.selectedSlot.time}`,
          `YYYY-MM-DDThh:mm a`
        ).format(`YYYY-MM-DDTHH:mm`);
      } else {
        date = this.$dayjs(
          `${this.calendar}T${this.selectedSlot.time}`,
          `YYYY-MM-DDTHH:mm`
        ).format(`YYYY-MM-DDTHH:mm`);
      }
      this.disabledButton = true;
      const upd = await apiBooking.reschedulingBooking(this.mkId, {
        rejection_reason: this.rejectionReason,
        comment: this.comment,
        tz_offset: this.defaultOffset,
        client_tz_offset: this.selectedTimezone.tz,
        client_timezone_text: this.selectedTimezone.name,
        client_time: this.clientTime,
        additional_info: this.additional_info,
        mk_starts_at: date,
        mk_ends_at: this.$dayjs(date, "YYYY-MM-DDTHH:mm")
          .add(1, "hour")
          .format("YYYY-MM-DDTHH:mm"),
      });
      await this.saveBookingTags(this.mkId)
      if (upd) {
        let time = !this.isMilitaryTime ? "hh:mm a" : "HH:mm";
        this.$toasted.global.all_ok(
          `${this.$t("mc.toasts.changeMcDate")} ${this.$dayjs(date).format(
            `DD.MM.YYYY ${time}`
          )}`
        );
        if (this.page === "detail") {
          this.$emit("close", { type: "reschedule", id: upd });
        } else if (this.page === "list-mk") {
          this.$emit("close", "reschedule");
        }
      }
      this.disabledButton = false;
    },
    fromMinutesToHHMM(minutes, negative) {
      const m = Math.abs(minutes) % 60;
      const h = Math.abs(minutes - m) / 60;
      return `${negative ? "-" : "+"}${h < 10 ? "0" : ""}${h.toString()}:${
        m < 10 ? "0" : ""
      }${m.toString()}`;
    },
  },
  async created() {
    const segment = this.$store.state.user.segment;
    if (this.type === "new-mk") this.disabledButton = false;
    this.loader = true;

    if (this.additionalInfoLoad) {
      this.additional_info = this.additionalInfoLoad;
    }

    this.segmentInfo = await apiUser.getSegmentInfoAndTime();
    // Устанавливаем дату в календарь на сегодня
    this.calendar = new Date();
    this.startDate = this.$dayjs(
      segment.segment_local_time,
      "YYYY-MM-DD HH:mm"
    ).format("YYYY-MM-DD");

    this.timezones = getTimeZones().map((el) => {
      const isNegativeMinutes = el.currentTimeOffsetInMinutes < 0;
      const returnObject = {
        utc: this.fromMinutesToHHMM(
          el.currentTimeOffsetInMinutes,
          isNegativeMinutes
        ),
        name: el.name,
        label: `(UTC ${this.fromMinutesToHHMM(
          el.currentTimeOffsetInMinutes,
          isNegativeMinutes
        )}) ${el.name}`,
        tz: el.currentTimeOffsetInMinutes * 60,
      };

      return returnObject;
    });

    this.selectedTimezone =
      this.timezones.find((el) => el.name === segment.timezone_name) ||
      this.timezones.find((el) => el.tz == segment.tz_offset);

    // Отображение времени под селектом
    this.displayTime = this.$dayjs(segment.segment_local_time).format(
      "DD.MM.YYYY HH:mm"
    );
    // Получение слотов за месяц
    this.getServerSlots(false, undefined, true);
  },
  watch: {
    triggerToDisableSaveButton(val) {
      if (val) this.disabledButton = val;
      this.$emit("toggleTriggerSaveButtonToDisable", false);
    },
    reason(val) {
      if (val) {
        this.rejectionReason = val;
        this.disabledButton = false;
        this.$emit("clearReason");
      } else return;
    },
  },
};
</script>

<style lang="scss" scoped>
.date-and-timezone {
  display: grid;
  grid-template-columns: 590px 1fr;
  column-gap: 20px;
  margin-bottom: 20px;
  background: #fff;
}
.slot-filled-circle {
  position: absolute;
  right: 12px;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  &_military {
    top: 5px;
    width: 10px;
    height: 10px;
    right: 8px;
  }
}
.registration {
  padding: 10px;
}
.registration-imposible {
  background: #f1f1f5;
  opacity: 0.7;
}

.date-and-timezone {
  display: grid;
  grid-template-columns: 590px 1fr;
  column-gap: 20px;
  margin-bottom: 20px;
  background: #fff;
}

.calendar-inline {
  &-container {
    background: #fff;
    padding-bottom: 48px;
  }
  &-description {
    display: flex;
    justify-content: center;
    font-size: 18px;
    color: var(--gray);
    &-text.is-available {
      color: #000;
      margin-right: 24px;
    }
  }
}

.right-panel {
  background: #fff;
  padding: 20px 0;
  padding-right: 10px;
  padding-top: 50px;
  &__title {
    display: block;
    margin-bottom: 10px;
    font-size: 24px;
    font-weight: 500;
    color: var(--black-title);
  }
  &-timezone {
    margin-bottom: 25px;
  }
  &__current-time {
    display: block;
    margin: 15px 0;
  }
}

.reshedule {
  &-time {
    width: 100px;
  }
  &-info {
    margin-top: 30px;
    display: block;
  }
}

.slots {
  &-lead {
    margin-top: 10px;
    margin-bottom: 10px;
    &-phone {
      display: flex;
      &__flag {
        display: flex;
        align-items: center;
      }
    }
  }
  &-avail {
    display: block;
  }
  &-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    &-time {
      position: relative;
      cursor: pointer;
      margin-bottom: 8px;
      margin-right: 8px;
      input {
        display: none;
        width: 0;
        height: 0;
      }
      &-content {
        border: 1px solid var(--main-blue);
        border-radius: 4px;
        min-width: 116px;
        max-width: 116px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-weight: 300;
        color: var(--main-blue);
        &.selected {
          background: var(--main-blue);
          color: #fff;
        }
      }
    }
  }
  &-selected {
    margin-top: 10px;
    &-amo {
      display: flex;
      justify-content: flex-start;
      &__input {
        margin-right: 18px;
        margin-bottom: 20px;
        max-width: 368px;
      }
    }
  }
}

.new-mk {
  &-comment {
    padding: 24px;
    background: #fff;
    &_without-padding {
      padding: 0;
    }
  }
  &__button {
    white-space: normal;
    margin-top: 20px;
  }
}

.order-timezone-checkbox {
  margin-bottom: 10px;
}
</style>
